import React from 'react'
import { Async } from 'react-async'
import fetchData from '../../modules/fetch-data'
import LayoutDefault from '../../layouts/Default'
import ScreenPage from './screens/ScreenPage'
import PropTypes from 'prop-types'
import { generatePathByRouteName } from '../../modules/named-router'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

const Wrapper = styled.div``

const Page = ({ initialData, match, location, view, ...props }) => (
  <Wrapper>
    {(initialData && initialData.notFound && <Redirect to="/p/error" />) || (
      <Async
        promiseFn={fetchData}
        location={match && generatePathByRouteName(view, { slug: match.params.slug }, 'api')}
        watch={match}
        initialValue={initialData}
      >
        {({ data, error, isPending, isFulfilled }) => (
          <LayoutDefault meta={isFulfilled && data.meta} {...props}>
            <ScreenPage
              response={isFulfilled && data}
              loading={isPending}
              error={error}
              ready={isFulfilled}
              match={match}
            />
          </LayoutDefault>
        )}
      </Async>
    )}
  </Wrapper>
)

Page.getInitialData = ({ req }) => {
  return fetchData({ location: req.url })
    .then((res) => res)
    .catch((err) => new Promise((resolve) => resolve({ notFound: true })))
}

Page.propTypes = {
  initialData: PropTypes.shape({
    meta: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    config: PropTypes.object,
  }),
  location: PropTypes.object,
  match: PropTypes.object,
}

Page.defaultProps = {
  location: {
    pathname: undefined,
  },
}

export default Page
